import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { completeSignIn } from '@/auth/authService';

export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) { setError('The authorization response is incomplete.'); return; }
    void completeSignIn(code, state).then(returnTo => navigate(returnTo, { replace: true })).catch((reason: unknown) => setError(reason instanceof Error ? reason.message : 'Sign-in failed'));
  }, [navigate, params]);
  return <main className="state-page"><div className="state-card"><span className="status-label" role="status">{error ? 'Error' : 'Signing in'}</span><h1>{error ? 'Sign-in failed' : 'Completing sign-in'}</h1><p>{error || 'Validating the secure callback…'}</p></div></main>;
}
